export const CHINESE_CALENDAR_SUPPORTED_YEARS = Array.from(
  { length: 51 },
  (_, i) => 2000 + i
);
export const MONTHS_KEYS = [
  "january",
  "february",
  "march",
  "april",
  "may",
  "june",
  "july",
  "august",
  "september",
  "october",
  "november",
  "december",
];
export const WEEK_KEYS = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
];
